import React from 'react';
import { useSearchContext } from '../../../../context';
import { highlightSearch } from '../../utils';
import { ColumnEntity } from '../../types';
import styles from './ColumnInfo.module.scss';
import convertColumnTypeToDisplayName from '../../../../util/ColumnTypeToDisplayNameConverter';

export type ColumnInfoProps = { column: ColumnEntity };

export const ColumnInfo: React.FC<ColumnInfoProps> = ({ column }) => {
  const [_, searchTerms] = useSearchContext();

  return (
    <div className={styles.container}>
      <span className={styles.name}>
        {highlightSearch(column.name(), searchTerms)}
      </span>
      <small className={styles.type}>
        {convertColumnTypeToDisplayName(column.type())}
      </small>
    </div>
  );
};

export const toColumnInfo = (column: ColumnEntity, index: number) => (
  <ColumnInfo key={`matching-column-${index}`} column={column} />
);
